import axios from 'axios';

export const getOutSourceList = (
  status: number,
  construct_sub: string,
  construct_code: string,
  user_id: number,
  supplier_name: string,
  customer_name: string,
  construct_start_date: string,
  construct_end_date: string,
  payment_start_date: string,
  payment_end_date: string,
  order_start_date: string,
  order_end_date: string,
  prefecture_name: string,
  address: string,
  current_page: number,
  display_limit: number,
  billing_total_start: number | null,
  billing_total_end: number | null,
  sort_direction: string | null,
  sort_field: string | null
) => {
  return axios
    .get(`/api/v1/outsources`, {
      params: {
        status,
        construct_sub,
        construct_code,
        user_id,
        supplier_name,
        customer_name,
        construct_start_date,
        construct_end_date,
        payment_start_date,
        payment_end_date,
        order_start_date,
        order_end_date,
        prefecture_name,
        address,
        page: current_page,
        display_limit,
        sort_direction,
        sort_field,
        billing_total_start,
        billing_total_end
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteOutsourceList = (outsources_list: any) => {
  return axios
    .post(
      `/api/v1/delete/outsources`,
      {
        outsources_list: outsources_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSingleOutsource = (id: number) => {
  return axios
    .delete(`/api/v1/outsources/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createOutSource = (
  id: number,
  user_id: number,
  job_start_date: string,
  job_end_date: string,
  order_date: string,
  order_status: number,
  payment_date: string,
  partner_id: number,
  honorific_title: string,
  billing_note: string,
  supervisor_id: number,
  vendor_representative: string,
  vendor_supervisor: string,
  items: any,
  estimate_id: any,
  memo: string
) => {
  return axios
    .post(
      `/api/v1/outsources/${id}`,
      {
        user_id,
        job_start_date,
        job_end_date,
        order_date,
        order_status,
        payment_date,
        partner_id,
        honorific_title,
        billing_note,
        supervisor_id,
        vendor_representative,
        vendor_supervisor,
        items,
        estimate_id,
        memo
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getOutSourceDetails = (id: number) => {
  return axios
    .get(`/api/v1/outsources/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateOutSource = (
  id: number,
  user_id: number,
  job_start_date: string,
  job_end_date: string,
  order_date: string,
  order_status: number,
  payment_date: string,
  partner_id: number,
  honorific_title: string,
  billing_note: string,
  supervisor_id: number,
  vendor_representative: string,
  vendor_supervisor: string,
  items: any,
  memo: string
) => {
  return axios
    .put(
      `/api/v1/outsources/${id}`,
      {
        user_id,
        job_start_date,
        job_end_date,
        order_date,
        order_status,
        payment_date,
        partner_id,
        honorific_title,
        billing_note,
        supervisor_id,
        vendor_representative,
        vendor_supervisor,
        items,
        memo
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateOutSourceInvoiceBillingTotal = (
  id: number,
  invoice_billing_total: number
) => {
  return axios
    .put(
      `/api/v1/outsources/${id}/partial-update`,
      {
        invoice_billing_total
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const copyOutSources = (outsource_id: number, construct_id: number) => {
  return axios
    .post(
      `/api/v1/copy/outsources/${outsource_id}`,
      { construct_id },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateOutsourceStatus = (outsource_id: number, status: number) => {
  return axios
    .put(
      `/api/v1/outsources/${outsource_id}/status`,
      {
        status
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const partialUpdateOutsourceStatus = (
  outsource_id: number,
  order_status: number
) => {
  return axios
    .put(
      `/api/v1/outsources/${outsource_id}/partial-update`,
      {
        order_status
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getExportOutsourcesItems = (
  selected_columns: any,
  status: number,
  construct_sub: string,
  user_id: number,
  supplier_name: string,
  customer_name: string,
  construct_start_date: string,
  construct_end_date: string,
  payment_start_date: string,
  payment_end_date: string,
  prefecture_name: string,
  address: string,
  order_start_date: string,
  order_end_date: string
) => {
  return axios
    .post(
      `/api/v1/export/outsources/list?status=${status}&construct_sub=${construct_sub}&user_id=${user_id}&supplier_name=${supplier_name}&customer_name=${customer_name}&construct_start_date=${construct_start_date}&construct_end_date=${construct_end_date}&payment_start_date=${payment_start_date}&payment_end_date=${payment_end_date}&order_start_date=${order_start_date}&order_end_date=${order_end_date}&prefecture_name=${prefecture_name}&address=${address}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getOutSourceExportDetails = (id: number) => {
  return axios
    .get(`/api/v1/export/outsource/${id}/details`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createOutsourceFromDocument = (enc_data: string) => {
  return axios
    .post(
      `/api/v1/import/outsource/document`,
      {
        enc_data
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateOutsourcePurchaseMemo = (
  outsource_id: number,
  memo: string
) => {
  return axios
    .put(
      `/api/v1/outsources/${outsource_id}/memo`,
      {
        memo
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
